if (!window.solvivoNav2Ready) {
  window.solvivoNav2Ready = true;
  document.addEventListener('click', event => {
    document.querySelectorAll('.sv-nav2__roots>li>details[open],.sv-nav2__mobile[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const opened = [...document.querySelectorAll('.sv-nav2 details[open]')].reverse();
    const details = opened.find(node => node.contains(document.activeElement)) ?? opened[0];
    if (details) { details.open = false; details.querySelector(':scope > summary')?.focus(); event.preventDefault(); }
  });
  document.addEventListener('toggle', event => {
    const details = event.target;
    if (details.matches?.('.sv-nav2__mobile') && details.open) {
      const header = details.closest('#header-component');
      if (header) details.style.setProperty('--sv-nav2-offset', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
    }
    if (!details.matches?.('.sv-nav2__roots>li>details') || !details.open) return;
    details.closest('.sv-nav2__roots').querySelectorAll(':scope > li > details[open]').forEach(sibling => { if (sibling !== details) sibling.open = false; });
  }, true);
  window.addEventListener('resize', () => {
    document.querySelectorAll('.sv-nav2__mobile[open]').forEach(details => {
      if (window.innerWidth >= 1100) { details.open = false; return; }
      const header = details.closest('#header-component');
      if (header) details.style.setProperty('--sv-nav2-offset', `${Math.max(0, header.getBoundingClientRect().bottom)}px`);
    });
  });
}
